import React from 'react';

import Search
    from './components/elemetor/widgets/Chapas_Norte_Cantos_DHL_Elementor_Widget/Chapas_Norte_Cantos_DHL_Elementor_Widget';
import Validator
    from './components/elemetor/widgets/Chapas_Norte_Cantos_Validator_Elementor_Widget/Chapas_Norte_Cantos_Validator_Elementor_Widget';
import Search_eng
    from './components/elemetor/widgets/Chapas_Norte_Cantos_DHL_Elementor_Widget/Chapas_Norte_Cantos_DHL_Elementor_Widget_eng';
import Validator_eng
    from './components/elemetor/widgets/Chapas_Norte_Cantos_Validator_Elementor_Widget/Chapas_Norte_Cantos_Validator_Elementor_Widget_eng';
import {createRoot} from 'react-dom/client';

const language = navigator.language;
const languageCode = language.substring(0, 2).toLowerCase();

document.addEventListener('DOMContentLoaded', function () {
    var element = document.getElementById('chapas_norte_cantos_dhl_elementor_widget');
    if (typeof element !== 'undefined' && element !== null) {
        const container = document.getElementById('chapas_norte_cantos_dhl_elementor_widget');
        const root = createRoot(container);
        if(languageCode === 'es'){
            root.render(<Search/>);
        }else {
            root.render(<Search_eng/>);
        }
    }
})

document.addEventListener('DOMContentLoaded', function () {
    var element = document.getElementById('chapas_norte_cantos_validator_elementor_widget');
    if (typeof element !== 'undefined' && element !== null) {
        const container = document.getElementById('chapas_norte_cantos_validator_elementor_widget');
        const root = createRoot(container);
        if (languageCode === 'es'){
            root.render(<Validator/>);
        }else {
            root.render(<Validator_eng/>);
        }
    }
})